import { all } from 'redux-saga/effects';

import handleConnectionStatus from './handleConnectionStatus';

export function* saga() {
    yield all([handleConnectionStatus()]);
}
